// extracted by mini-css-extract-plugin
export default {"tenant_profile_content":"TenantProfile_tenant_profile_content__WKPAM","next_payment_invoice":"TenantProfile_next_payment_invoice__EwOT6"};